import { render, staticRenderFns } from "./deskPayModal.vue?vue&type=template&id=1bdab4ba&"
import script from "./deskPayModal.vue?vue&type=script&lang=js&"
export * from "./deskPayModal.vue?vue&type=script&lang=js&"
import style0 from "./deskPayModal.vue?vue&type=style&index=0&id=1bdab4ba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports